// Layout class
// If you add new class then please work on frontend app too. (lotto-ui)
export const LAYOUT_CLASS = {
  CONTAINER: 'w-full max-w-7xl',
  ROW: 'mt-6',
  GRID_TWO_COLUMNS:
    'grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-4 items-start',
}
